import { render, staticRenderFns } from "./CoffeeCardTiled.vue?vue&type=template&id=4e9d5fc0&"
import script from "./CoffeeCardTiled.vue?vue&type=script&lang=js&"
export * from "./CoffeeCardTiled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e9d5fc0')) {
      api.createRecord('4e9d5fc0', component.options)
    } else {
      api.reload('4e9d5fc0', component.options)
    }
    module.hot.accept("./CoffeeCardTiled.vue?vue&type=template&id=4e9d5fc0&", function () {
      api.rerender('4e9d5fc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/CoffeeCardTiled.vue"
export default component.exports